import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Loader from "../../shared/loader";
import { NotifyModel } from "../../models/Auth.model";
import Notify from "../../shared/Notify";
import { userPermissions } from "../../constants/UserPermissions.constants";
import Button from "@material-ui/core/Button";
import { CheckboxInput } from "../../widgets/CheckBoxInput";
import {
  addRole,
  getAllRolePermissions,
  getRoleService,
  updateRolePermissions,
} from "../../services/policy.service";
import BreadCrumb from "../../shared/BreadCrumb";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";
import AddRole from "../../shared/AddRole";
import "./permissions.css";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && <div className="permission-layout">{children}</div>}
    </div>
  );
}
export default function Permissions(props) {
  const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
      width: "100%",
      backgroundColor: theme.palette.background.paper,
    },
  }));
  const { match } = props;
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(false);
  const [notifyProps, setNotifyProps] = useState(NotifyModel);
  const [isLoader, setIsLoader] = useState(false);
  const [value, setValue] = useState(0);
  const [permissionData, setPermissionsData] = useState([]);
  const [selected, setSelected] = useState([]);
  const [open, setOpen] = useState(false);
  const [header, setHeader] = useState([]);
  const [roleLoader, setRoleLoader] = useState(false);
  const [tabValue, setTabValue] = useState("UNDERWRITING");
  useEffect(() => {
    getAllPermissions();
    getRoleList();
  }, []);

  const getRoleList = () => {
    getRoleService().then(
      (result) => {
        if (result && result.data.statusCode === 200) {
          setHeader(result.data.response);
        } else {
        }
      },
      (error) => {},
    );
  };

  const getAllPermissions = () => {
    setIsLoading(true);
    getAllRolePermissions().then(
      (result) => {
        setIsLoading(false);
        if (result && result.data.statusCode === 200) {
          let data = result.data.response;
          filterData(tabValue, data);
          setPermissionsData(data);
        } else {
          setIsLoading(false);
        }
      },
      (error) => {
        setIsLoading(false);
      },
    );
  };

  const handleChange = (event, newValue) => {
    event.persist();
    filterData(event.target.textContent, permissionData);
    setValue(newValue);
    setTabValue(event.target.textContent);
  };

  function filterData(changedValue, prevData) {
    let tempData = [];
    prevData.forEach((element) => {
      if (element.department === changedValue) {
        tempData.push(element);
        setSelected(tempData);
      }
    });
  }

  function a11yProps(index) {
    return {
      id: `scrollable-auto-tab-${index}`,
      "aria-controls": `scrollable-auto-tabpanel-${index}`,
    };
  }

  const handleCheckbox = (evt, id) => {
    evt.persist();
    let prevData = [...permissionData];
    prevData.forEach((element) => {
      if (element.id === id) {
        let data = Object.keys(element.role);
        data.forEach((el) => {
          if (el === evt.target.name) {
            element.role[el] = evt.target.checked;
          }
        });
      }
    });
    setPermissionsData(prevData);
  };

  function filterSaveData() {
    let newData = [...permissionData];
    newData.forEach((element) => {
      delete element["department"];
    });
    return newData;
  }
  const savePermissions = () => {
    setIsLoader(true);
    updateRolePermissions(filterSaveData()).then(
      (result) => {
        setIsLoader(false);
        if (result && result.data.statusCode === 200) {
          setNotifyProps({
            ...notifyProps,
            message: result.data.message,
            type: "success",
            toggle: true,
          });
          getAllPermissions(tabValue);
        } else {
          setNotifyProps({
            ...notifyProps,
            message: result.data.message,
            type: "error",
            toggle: true,
          });
          setIsLoader(false);
        }
      },
      (error) => {
        setNotifyProps({
          ...notifyProps,
          message: "Service Failed",
          type: "error",
          toggle: true,
        });
        setIsLoader(false);
      },
    );
  };
  const openModal = () => {
    setOpen(true);
  };

  const modalClose = () => {
    setOpen(false);
  };
  const handleSubmitModal = (data) => {
    setRoleLoader(true);
    addRole(data).then(
      (result) => {
        setRoleLoader(false);
        if (result && result.data.statusCode === 200) {
          modalClose();
          setNotifyProps({
            ...notifyProps,
            message: result.data.message,
            type: "success",
            toggle: true,
          });
          getAllPermissions();
          getRoleList();
        } else {
          setNotifyProps({
            ...notifyProps,
            message: result.data.message,
            type: "error",
            toggle: true,
          });
        }
      },
      (error) => {
        setNotifyProps({
          ...notifyProps,
          message: "Service Failed",
          type: "error",
          toggle: true,
        });
        setRoleLoader(false);
      },
    );
  };

  return (
    <>
      <div className={classes.root}>
        <div className="permission-menu">
          {" "}
          {match !== undefined ? <BreadCrumb breadcrumb={match.url} /> : null}
          <div className="save-permi-button">
            <Button
              variant="contained"
              color="primary"
              onClick={savePermissions}
              disabled={isLoader}
            >
              {" "}
              {isLoader ? "Saving" : "Save Permissions"}
            </Button>{" "}
          </div>
        </div>
        <TabPanel value={value} index={value}>
          <div className="zui-wrapper">
            <div className="zui-scroller">
              <table className="table table-striped table-hovered table-fixed bt-table zui-table">
                <thead>
                  <tr>
                    <th className="zui-sticky-col">Permissions</th>
                    {header
                      ? header.map((item) => {
                          return <th className="text-center">{item.role}</th>;
                        })
                      : null}
                  </tr>
                </thead>
                <tbody>
                  {selected &&
                    selected.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td className="zui-sticky-col  font-size-11">
                            <div>{item.permission}</div>
                          </td>
                          {Object.keys(item.role).map((subItem, subIndex) => {
                            return (
                              <td key={subIndex} className="text-center">
                                <CheckboxInput
                                  id={subItem}
                                  size="small"
                                  name={subItem}
                                  checked={item.role[subItem]}
                                  onChange={(e) => handleCheckbox(e, item.id)}
                                  color="skyBox"
                                  className="defaultLable"
                                />
                              </td>
                            );
                          })}
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>
        </TabPanel>
        <div className="save-permissions">
          <AppBar position="static" color="default">
            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="primary"
              textColor="primary"
              variant="scrollable"
              scrollButtons="auto"
              aria-label="scrollable auto tabs example"
            >
              {userPermissions.map((item, index) => {
                return <Tab label={item.label} {...a11yProps(item.key)} />;
              })}
            </Tabs>
          </AppBar>
        </div>
        <div className="fab-add-button">
          <Fab color="primary" aria-label="add" onClick={openModal}>
            <AddIcon />
          </Fab>
        </div>
      </div>

      <Notify notifyProps={notifyProps} />
      <Loader open={isLoading} />
      <AddRole
        open={open}
        closeNotes={modalClose}
        handleSubmit={handleSubmitModal}
        roleLoader={roleLoader}
      />
    </>
  );
}
